/**
 * @generated SignedSource<<455e732640d878ff1d5aa07efdb9d772>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorefrontMediaSection_viewer$data = {
  readonly vimeoStorefrontVideoHLSPlayerFF: boolean | null;
  readonly " $fragmentType": "StorefrontMediaSection_viewer";
};
export type StorefrontMediaSection_viewer$key = {
  readonly " $data"?: StorefrontMediaSection_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorefrontMediaSection_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontMediaSection_viewer",
  "selections": [
    {
      "alias": "vimeoStorefrontVideoHLSPlayerFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "vimeoStorefrontVideoHLSPlayer"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"vimeoStorefrontVideoHLSPlayer\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "eaa275ff2acb369f630931540c8ca925";

export default node;
